import {FrameReducer} from '../../frame'

export default FrameReducer;
